import { useIsMobileEmailUser } from "@/app/hooks/use-is-mobile-email-user"
import { Trans } from "@lingui/react/macro"
import { AppToast, SuccessViewTransaction } from "./app-toast"
import { useToastError } from "./toast-util"

export const CancelByOrderToast = {
  Error: function CancelToastError({
    id,
    error,
  }: { id: string | number; error: unknown }) {
    const { message, type } = useToastError(error)

    if (type === "destructive") {
      return (
        <AppToast.Error
          id={id}
          title={"Error during order cancellation"}
          main={<Trans>Error during order cancellation</Trans>}
          second={
            <div className="font-semibold text-destructive">{message}</div>
          }
        />
      )
    } else if (type === "surface") {
      return (
        <AppToast.Warning
          id={id}
          title={"Error during order cancellation"}
          main={<Trans>Error during order cancellation</Trans>}
          second={
            <div className="font-semibold text-muted-foreground">{message}</div>
          }
        />
      )
    }
  },
  Pending: function CancelToastPending({ id }: { id: string | number }) {
    const isMobileEmailUser = useIsMobileEmailUser()

    if (isMobileEmailUser) {
      return null
    }

    return (
      <AppToast.Pending
        id={id}
        title={"Order is cancelling"}
        main={<Trans>Order is cancelling</Trans>}
        second={
          <div className="font-semibold text-muted-foreground">
            <Trans>Pending...</Trans>
          </div>
        }
      />
    )
  },
  Success: function CancelToastSuccess({
    id,
    transactionId,
    blockchain,
  }: {
    id: string | number
    transactionId: string
    blockchain: import("@anaconda/core/blockchain/types").Blockchain
  }) {
    return (
      <AppToast.Success
        id={id}
        title={"Order was successfully cancelled"}
        main={<Trans>Order was successfully cancelled</Trans>}
        second={
          <SuccessViewTransaction
            transactionId={transactionId}
            blockchain={blockchain}
          />
        }
      />
    )
  },
}
